export const log = (v) => console.log(v);
